import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL; // Replace with your actual API base URL

const ApiKeyApiService = {
    getApiKeys: async (userId) => {
        try {
            const response = await axios.get(`${BASE_URL}Setting/Get/Keys?userId=${userId}`);
            return response.data; // Returns the list of API keys
        } catch (error) {
            console.error('Error fetching API keys:', error);
            throw error; // Rethrow error to handle it in the component
        }
    },
    generateKey: async (obj) => {
        try {
            const response = await axios.post(`${BASE_URL}Setting/Generate/Key`,obj);
            return response; // Returns the list of API keys
        } catch (error) {
            console.error('Error fetching API keys:', error);
            throw error; // Rethrow error to handle it in the component
        }
    }
};

export default ApiKeyApiService;
